module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', [_vm._v("Alluring Lettuces")]), _vm._v(" "), _c('div', {
    staticClass: "toc"
  }, [_c('dl', [_c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "href": "#/ch01"
    }
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "href": "#/ch02"
    }
  }, [_vm._v("1. Amaranth ‘Joseph’s Coat’")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "href": "#/ch03"
    }
  }, [_vm._v("2. Artichoke ‘Violetto di Romagna’")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "href": "#/ch04"
    }
  }, [_vm._v("3. Asparagus Bean (Yard Long White Snake)")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "href": "#/ch05"
    }
  }, [_vm._v("4. Asparagus Pea")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "href": "#/ch06"
    }
  }, [_vm._v("5. Australian Yellowleaf Lettuce ")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Broccoli ‘Romanesco’")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Brussels Sprout ‘Rubine’")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Bull’s Blood Beet")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Cabbage ‘Ruby Perfection’")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Cabbage ‘Savoy Express’")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. Cardoon ‘Gigante’")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. Carrot ‘Thumbelina’")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. Cauliﬂower ‘Violetta di Sicilia’")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. Cayenne Pepper")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. Celeriac")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. Chard ‘Bright Lights’")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. Chinese Rat Tail Radish")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18. Chiogga Beet")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19. Crimson Forest Onion")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20. d’Algers Melon")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21. Dragon Tongue Bush Bean")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22. Dwarf Blue Curled Scotch Kale")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23. Early Purple Vienna Kohlrabi")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24. Eggplant ‘Neon’")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25. Egyptian Walking Onion")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26. Elberta Peach Tomato")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27. Fish Pepper")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28. ‘German Red Strawberry’ Tomato")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29. Giant Chinese Red Mustard")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30. Giant Red Celery")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31. Golden Sweet Edible-Podded Pea")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32. Green Zebra Tomato")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33. Habañero Pepper")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34. Hillbilly Tomato")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35. Imperial Star Artichoke")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36. Jarrahdale Pumpkin")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37. Kale Nero di Toscana")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38. Leek ‘Blue Solaise’")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39. Lemon Drop Pepper")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40. Lettuce ‘Forellenschluss’")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41. Lollo Rossa Lettuce")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42. Malabar Spinach")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43. Melon ‘Queen Anne’s Pocket’")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44. Merlot Lettuce")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45. Mizuna")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46. Nutri-Red Carrot")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47. Okra ‘Red Burgundy’")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48. Orach ‘Crimson Plume’")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49. Osterei Eggplant")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50. Painted Serpent Cucumber")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51. Prescott Fond Blanc Melon")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52. Pumpkin ‘Baby Boo’")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53. Purple Calabash Tomato")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54. Purple Sprouting Broccoli")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55. Radish ‘Misato Rose’")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56. Redbor Kale")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57. Rhubarb Chard")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58. Royal Oakleaf Lettuce")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59. Runner Bean ‘Painted Lady’")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60. Runner Bean ‘Sun Bright’")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61. Sea Kale")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62. Sorrel ‘Silver Shield’")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63. Squash ‘Ronde de Nice’")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64. Sunburst Squash")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65. Sweet Million Tomato")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66. Tiger Tom Tomato")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67. Trifetti Pepper")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68. True Lemon Cucumber")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69. Turkish Orange Eggplant")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70. Watermelon ‘Moon & Stars’")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71. West Indian Burr Gherkin")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72. Windsor Broad Bean")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73. Wood’s Prolific Bush Scallop Squash")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74. Yellowstone Carrot")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75. Zebra Hybrid Eggplant")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Resources")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-493b3cdc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bk01-toc.vue
// module id = 66
// module chunks = 0